import {useState} from 'react';
import {useLocation} from 'react-router-dom';

import {useHttpCalls} from '../../../../../api/useHttpCalls';
import {useEagGridConfig} from '../../../../../context/useEagGridConfig';
import {useEagGridStore} from '../../../../../store/useEagGridStore';
import {SharePresetStateEnum} from '../../../../../types/SharePresetStateEnum';
import {buildSharePresetUrl} from '../../../../../utils/buildSharePresetUrl';

export const useSharePreset = (onCloseCallback?: () => void) => {
  const http = useHttpCalls();
  const store = useEagGridStore();
  const location = useLocation();
  const {buildAbsoluteUrl} = useEagGridConfig();
  const [shareUrl, setShareUrl] = useState<string | null>(null);
  const [sharePresetState, setSharePresetState] = useState<SharePresetStateEnum>(
    SharePresetStateEnum.LOADING
  );

  const onClose = () => {
    onCloseCallback?.();
    setSharePresetState(SharePresetStateEnum.LOADING);
    setShareUrl(null);
  };

  const sharePreset = () => {
    const gridCode = store.getState().gridCode;
    http
      .sharePreset({
        gridSettings: true,
        columnSettings: true,
        filters: true,
        order: true,
      })
      .then((res) => {
        setSharePresetState(SharePresetStateEnum.FINISHED);
        res?.sharedPresetId &&
          buildAbsoluteUrl &&
          setShareUrl(
            buildSharePresetUrl(buildAbsoluteUrl, gridCode, res.sharedPresetId, location.pathname)
          );
      })
      .catch(() => {
        setSharePresetState(SharePresetStateEnum.ERROR);
      });
  };

  return {
    shareUrl,
    sharePresetState,
    sharePreset,
    onClose,
  };
};
